module.exports = __webpack_public_path__ + "static/media/dodi.028534a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/Team/dodi.jpg
// module id = 174
// module chunks = 0